import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterHorizontal = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 4.6665H6.66667M6.66667 4.6665C6.66667 5.77107 7.5621 6.6665 8.66667 6.6665H9.33333C10.4379 6.6665 11.3333 5.77107 11.3333 4.6665C11.3333 3.56193 10.4379 2.6665 9.33333 2.6665H8.66667C7.5621 2.6665 6.66667 3.56193 6.66667 4.6665ZM10.6667 11.3332H14M13.3333 4.6665H14M2 11.3332H4M4 11.3332C4 12.4377 4.89543 13.3332 6 13.3332H6.66667C7.77124 13.3332 8.66667 12.4377 8.66667 11.3332C8.66667 10.2286 7.77124 9.33317 6.66667 9.33317H6C4.89543 9.33317 4 10.2286 4 11.3332Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgFilterHorizontal);
export default ForwardRef;
